import React from 'react';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1 className="about-title">대구성서아카데미를 소개합니다.</h1>

        <div className="about-content">
          <p>
            &lt;대구 성서 아카데미&gt;를 찾아주신 것에 대해 감사드립니다. 대구성서아카데미의 홈페이지 주소인 dabia의 da는 "대구" 영문자인 daegu의 약자이면, bi는 "성서" 영문자인 bible의 약자이고, a는 academy의 약자입니다. 편의상 dabia를 "다비아"라고 부르면 됩니다. 다시 한번, 다비아를 찾아주신 분께 감사드립니다.
          </p>

          <p>
            다비아의 시작은 다음과 같습니다. 2001년 10월부터 대구YMCA 중부지회에서 "지성인을 위한 성서연구" 모임이 정용섭목사를 강사로 시작되었습니다. 다음 해인 2002년 4월까지 빌립보서를 공부한 후, 5월부터 누가복음을 공부했습니다. 그 과정에서 이런 평신도만을 위한 성서연구가 아니라 교역자및 교회 지도자를 대상으로 한 공부모임이 필요하다는 생각을 했습니다. 그래서 정용섭목사는 6월부터 &lt;말씀과 삶&gt;이라는 월간 간행물을 발행하는 것으로부터 주변에 이런 모임을 알려나갔습니다. 10월 21일 지산동에 있는 수성성결교회당에서 제1회 "설교공부" 모임을 가졌습니다. 30여명의 목사, 장로, 신학생들이 참가했습니다. "탈식민지적 글쓰기와 설교문제"를 주제로 정용섭목사의 특강이 있었습니다. 12월에는 "설교주제로서의 생명문제"라는 제목으로 2회 모임이 있었습니다.
          </p>

          <p>
            이제 시작하는 단계이기 때문에 특별한 조직은 없습니다. 2003년1월7일에 있었던 운영위원장, 총무, 간사, 원장의 연석회의 때 우리의 이 공부모임이 실천적 단계로 발전되었으면 하는 바램이 있었습니다. 탄탄한 공부와 실천이 조화를 이룬 운동체로서의 발전을 꿈꾸었습니다. 이를 위해서 우선 이 모임의 내용을 내실화하는 작업에 힘을 모아야 하겠습니다. 아래는 &lt;말씀과 삶&gt; 제1호(2002.6.1발행)에 실렸던 아카데미 창립의 변입니다.
          </p>

          <div className="quote-box">
            <p>
              &lt;대구성서 아카데미&gt;는 성서를 바르게 이해하려는 사람들에게 여러 방향에서 도움을 주려고 시작한 공부 모임이며 동시에 운동입니다. 물론 성서 공부는 지금까지 여러 곳에서 여러 형태로 제공되고 있습니다만 이미 성숙한 기독교인들이 주류로 등장하는 이 시대의 변화 앞에서 그것으로는 약간 미흡한 게 아닌가 생각했습니다. 일반적으로 성서 공부가 흡사 입시생들이 수학공식이나 영어숙어 암기하듯이 지나치게 이론적인 방향으로 치우쳐 있거나, 아니면 지나치게 실용적인 차원만 강조하고 있습니다. 예컨대 한국 교회에서는 큐티 류의 성서연구가 가장 전형적인 방법론으로 자리잡고 있습니다. 이런 정도의 진지한 자세로 성서를 대할 수 있다는 사실만 하더라도 한국 교회가 상당한 수준에 도달했다고 볼 수도 있습니다만 대개의 경우에 그런 성격의 공부에서는 신자들의 주관적 욕구가 크게 작용합니다. 성서가 담고 있는 고유한 세계를 이해하는 것보다는 그것을 읽는 사람의 개인적이고 실존적인 경험이 훨씬 중요한 요소로 작동됩니다. 일종의 인간론 중심의 성서읽기입니다. 우리가 믿고 있는 하나님이 신뢰할만한 대상이라는 점을 확증하지 않고 무조건 믿는다면 그것은 자기 확신이나 자기만족에 떨어질 염려가 다분합니다.
            </p>

            <p>
              &lt;대구성서 아카데미&gt;의 성서읽기는 인간의 종교경험보다는 하나님 자체에 중점을 둘 것입니다. 그렇다고 해서 단지 관념적인 하나님을 모색하는 게 아니라 우리의 삶에서 하나님의 리얼리티를 구체적으로 확보하는 방식입니다. 이것은 일종의 생명지향적 성서읽기라고 할 수 있습니다. 여기서 말하는 생명은 곧 오늘의 인문, 자연과학이 화두로 삼고 있는 바로 그것입니다. 우리가 성서의 세계를 이해하려면 우선 생명의 깊이를 파악해야합니다. 많은 사람들이 생물학적인 면에서나 철학적인 면에서 생명의 본질을 밝혀보려고 오랫 동안 노력했으며 지금도 역시 그렇습니다. 그들과의 대화는 우리가 성서를 읽고 이해하는데 많은 도움을 줄 것입니다. 아주 작은 꿈을 갖고 시작하는 &lt;대구성서 아카데미&gt;는 다음과 같이 간소한 활동에서부터 문을 엽니다. 하나는 정기적인 성서연구입니다. 현재 대구 YMCA에서 매주 화요일 저녁 7시30분-9시에 누가복음의 인물을 중심으로 진행되고 있습니다. 두 번째는 목회자들을 위한 설교 공부입니다. 격월간으로 정기 모임을 갖는 게 좋을 것 같습니다. 설교의 테크닉이 아니라 주로 설교의 방향이나 본질에 대한 이야기를 나눔으로써 설교의 지평을 심화시켜나가는 작업이라 할 수 있습니다. 구체적인 계획은 다음 소식지로 나갈 예정입니다. 세 번째는 소식지 &lt;말씀과 삶&gt; 발행입니다. 당분간 다음과 같은 내용으로 월1회 발행됩니다. 판넨베르크의 설교, 빌립보서 연구, 지상 설교학 강의, 신학 단상, 서평, 유럽기행, 퍼온글 등등. 앞으로 적당한 필진이 확보되면 좀더 알찬 내용으로 꾸려가게 되겠지만 일단 이 정도의 내용으로 시작하겠습니다. 많은 조언을 부탁드립니다.
            </p>

            <p>
              &lt;대구성서 아카데미&gt;라는 이름에 대해서 조금 더 설명하겠습니다. 이 이름에는 세 개의 단어가 조합되어 있습니다. 대구, 성서, 아카데미. 대구는 경북 전체를 포괄하는 상징적 의미입니다. 성서는 단지 하나의 책인 성서만을 가리키는 게 아니라 지난 2천년 동안의 기독교 역사 전체를 그 안에 담고 있습니다. 아카데미는 원래 플라톤이 기원전 385년 그리스의 헤카데모스 숲속에 세운 학당 이름입니다. 굳이 외국어를 쓸 필요가 없긴 하겠지만 인문학적 전통을 잇는다는 뜻에서 붙인 이름이니까 양해를 바랍니다. &lt;대구성서 아카데미&gt;(이하 아카데미)는 대구 경북이라는 지역적 특성, 성서라는 기독교 정체성, 아카데미라는 방향성을 토대로 하는 기독교인의 지성적 운동입니다.
            </p>

            <p>
              오늘 우리는 교회와 기독교인의 참모습이 무엇인지 진지하게 검토해야할 시기에 와 있습니다. 그 이유는 분명합니다. 지난 30년 가까이 물불 가리지 않고 교회성장에만 목표를 두고 지내온 우리 기독교인들과 교회가 그 이후의 시대를 준비하지 못했다는 것이 그 대답입니다. 현실적으로 교회성장이 멈춘 상태에서 단지 해외선교나 사회복지활동에서 그 돌파구를 찾는다는 것은 또 하나의 방법론에 빠져버리는 셈입니다. 성서와 2천년 교회역사를 토대로 해서 기독교 신앙의 본질을 모색하는 것이야말로 자기 자신을 위해서나 사회를 위해서 교회가 추구해야할 가장 우선적이고 유일한 작업입니다. 앞으로 &lt;아카데미&gt;는 맹목적인 신앙에 빠지지 않을 뿐만 아니라 시대정신에 함몰되지도 않는, 그야말로 종말론적인 희망을 안고 역사변혁에 참여하고자 하는 기독교인들에게 약간이나마 도움이 되었으면 합니다.
            </p>

            <p>
              &lt;아카데미&gt;는 아직 이렇다할 조직없이 시작합니다. 다만 제가 원장으로 자임했습니다. 앞으로 이런 공부와 운동이 지속되어야 한다는 서로의 생각이 맞아떨어지면 자연스럽게 최소한이나마 조직되지 않을까 생각하고, 또한 그렇게 기대합니다. 이 모임에 대해서 주위 분들에게 알려주시면 고맙겠습니다.
            </p>
          </div>

          <h2 className="section-title">원장 프로필</h2>

          <div className="profile-section">
            <img
              src="/images/profile.jpg"
              alt="원장 프로필"
              className="profile-image"
            />

            <div className="profile-content">
              <p>
                정용섭 목사는 1953년 서울에서 출생, 서울신학대학교, 대학원을 졸업하고, 독일 뮌스터 대학교를 거쳐, 계명대학교(신학박사)에서 공부했다. 대구대학교와 계명대학교와 영남신학대학교 강사를 역임했으며, 현풍제일교회와 대구샘터교회 담임 목사를 거쳐서, 지금은 대구성서아카데미 원장으로 활동하면서 다샘교회와 서울샘터교회 설교 목사로 있다.
              </p>

              <h3>쓴 책</h3>
              <ul>
                <li>말씀신학과 역사신학 (한국신학연구소, 1995)</li>
                <li>믿음으로 본 세상 (대장간, 1996)</li>
                <li>세상 인간 하나님 (쿰란출판사, 1997)</li>
                <li>세계구원 교회구원 (쿰란출판사, 1999)</li>
                <li>기독교를 말한다 (한들출판사, 2001)</li>
                <li>땅과 하늘 (대구성서아카데미, 2003)</li>
                <li>사람 사랑 삶 (대구성서아카데미, 2003)</li>
                <li>법과 자유 (대구성서아카데미, 2005)</li>
                <li>설교비평집1, 속빈설교 꽉찬설교 (대한기독교서회, 2006)</li>
                <li>설교비평집2, 설교와 선동 사이에서 (대한기독교서회, 2007)</li>
                <li>설교비평집3, 설교의 절망과 희망 (대한기독교서회, 2008)</li>
                <li>설교집1, 그날이 오면 (다비아책, 2008)</li>
                <li>기독교가 뭐꼬? (다비아책, 2009)</li>
                <li>설교집2, 하나님의 얼굴 (다비아책, 2009)</li>
                <li>신학단상1, 세상은 마술이다 (다비아책, 2009)</li>
                <li>그림이 있는 오병이어 이야기 (다비아책, 2010)</li>
                <li>설교란 무엇인가 (홍성사, 2011)</li>
                <li>주기도란 무엇인가 (홍성사, 2011)</li>
                <li>매일 기도하라 (한들출판사, 2013)</li>
                <li>설교집3, 거룩한 두려움 (한들출판사, 2013)</li>
                <li>신학과 설교 (대구성서아카데미 2013)</li>
                <li>신학공부 (대구성서아카데미, 2014)</li>
                <li>판넨베르크의 &lt;사도신경해설&gt; 강독 (대구성서아카데미, 2015)</li>
                <li>신학과 철학 (대구 성서아카데미 2015)</li>
                <li>매일 묵상 (대구성서아카데미 2017)</li>
                <li>목사공부 (새물결플러스, 2017)</li>
                <li>욥 이야기 (대구성서아카데미 2018)</li>
                <li>마가복음을 읽는다 1 (홍성사 2019)</li>
                <li>마가복음을 읽는다 2 (홍성사 2019)</li>
                <li>설교 단편 (대구성서아카데미 2019)</li>
                <li>목사구원 (새물결플러스, 2020)</li>
                <li>흔들리지 않는 나라 (대구성서아카데미 2021)</li>
                <li>설교 단편 2 (대구성서아카데미 2022)</li>
              </ul>

              <h3>옮긴 책</h3>
              <ul>
                <li>도로테 죌레, 땅은 하나님의 것이다 (한국신학연구소, 1999)</li>
                <li>콧체 편, 에큐메니칼 교회사 3 (한국신학연구소, 2000)</li>
                <li>판넨베르크, 사도신경해설 (한들출판사, 2000)</li>
                <li>판넨베르크, 신학과 철학 (한들출판사, 2001)</li>
                <li>판넨베르크, 여기 계신 하나님 (대구성서 아카데미, 2002)</li>
                <li>판넨베르크의 조직신학 1 (공역, 은성출판사, 2003)</li>
                <li>판넨베르크 설교집, 믿음의 기쁨 (대구성서 아카데미, 2007)</li>
                <li>칼 바르트의 신학묵상 (공역, 대한기독교서회, 2009)</li>
              </ul>
            </div>
          </div>

          <div className="contact-info">
            <p>주소: 경북 영천시 북안면 대원당길 111</p>
            <p>전화: 010-8577-1227</p>
            <p>이메일: <a href="mailto:freude103801@hanmail.net">freude103801@hanmail.net</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
